<template>
    <div></div>
</template>

<script>
export default {
    name: "PrometEdit"
}
</script>

<style scoped>

</style>